import { render, staticRenderFns } from "./userBasicInformation.vue?vue&type=template&id=4651f73e&"
import script from "./userBasicInformation.vue?vue&type=script&lang=ts&"
export * from "./userBasicInformation.vue?vue&type=script&lang=ts&"
import style0 from "./userBasicInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports